// extracted by mini-css-extract-plugin
var _1 = "TablePagination-moduleTablePagination__cupJ7";
var _2 = "TablePagination-moduleonePage__EMyPa";
var _3 = "TablePagination-moduleskeletonBar__kmqMg Skeleton-moduleSkeleton__Mlrfv";
var _4 = "TablePagination-moduleskeletonContainer__LfpuD";
var _5 = "TablePagination-moduleskeletonSquare__S9pte Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "TablePagination", _2 as "onePage", _3 as "skeletonBar", _4 as "skeletonContainer", _5 as "skeletonSquare" }
